import { all } from 'redux-saga/effects';

import requestLeaveWatcher from './request-leave-saga';

export default function* rootSaga(action) {
	yield all([requestLeaveWatcher(action)]);
}
